<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "light"
    }
  },
  computed: {
    config() {
      const types = {
        button: {
          small: true,
          variant: this.variant,
          wrapperClass: "",
          spinnerClass: "me-2"
        },
        block: {
          small: false,
          variant: this.variant,
          wrapperClass: "py-3 text-center",
          spinnerClass: ""
        }
      }

      return types[this.type] || types.block
    }
  }
}
</script>

<template>
  <div v-if="loading" :class="config.wrapperClass">
    <BSpinner
      :small="config.small"
      :variant="config.variant"
      :class="config.spinnerClass"
    />
  </div>

  <template v-else>
    <slot />
  </template>
</template>